// extracted by mini-css-extract-plugin
export default {"header":"international-blocker__header","body":"international-blocker__body"};